import {useTheme} from "@mui/material";
import {Bar, BarChart, CartesianGrid, Cell, Tooltip, XAxis, YAxis} from "recharts";
import Message from "../../../pages/components/message";
import {MessageSections} from "../../../pages/components/message/message";
import {BarContainer, TotalCardTitle} from "../styled";
import NoOrders from "../../../pages/orders/my/no-orders";
import {ChartData} from "../dashboard-page";
import {DashboardTooltip} from "./tooltip";

const BarekamBar = ({data, title, extended}: BarekamBarProps) => {
    const theme = useTheme();

    return (
        <BarContainer style={{minHeight: extended ? '33rem' : 'unset'}}>
            <TotalCardTitle>
                <Message messageKey={title} sectionId={MessageSections.ORDERS}/>
            </TotalCardTitle>

            {data.length
                ? <BarChart
                    width={500}
                    height={extended ? 340 : 260}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}>
                    <CartesianGrid vertical={false}/>
                    <XAxis dataKey="name" axisLine={false}/>
                    <YAxis  axisLine={false}/>
                    <Tooltip content={DashboardTooltip}/>
                    <Bar dataKey="value" isAnimationActive={false}>
                        {data.map(({value, name}, index) => (
                            <Cell key={`cell-${name}`} fill={theme.barekam.dashboard.barColors[index] || '#000'} />
                        ))}
                    </Bar>
                </BarChart>
                : <NoOrders messageKey={'no_total_orders'}/>
            }
        </BarContainer>
    );
};

interface BarekamBarProps {
    data: ChartData[],
    title: string,
    extended?: boolean
}

export default BarekamBar;
